module.exports = __webpack_public_path__ + "static/media/miette.7a4b80fb.png";